/**
 * @generated SignedSource<<abb006f889b1d52b2e7046bcb802027e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type itemVideoSectionSearchResultListItemVideoSection$data = {
  readonly entityId: string;
  readonly name: string;
  readonly urlAlias: string;
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  readonly " $fragmentType": "itemVideoSectionSearchResultListItemVideoSection";
};
export type itemVideoSectionSearchResultListItemVideoSection$key = {
  readonly " $data"?: itemVideoSectionSearchResultListItemVideoSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"itemVideoSectionSearchResultListItemVideoSection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "itemVideoSectionSearchResultListItemVideoSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlAlias",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    }
  ],
  "type": "VideoSection",
  "abstractKey": null
};

(node as any).hash = "e85617a555d29c115e5056067e0674c3";

export default node;
